export default function() {
	let isWindows = false;
	let isMacOS = false;

	if(window.navigator.userAgentData) {
		isWindows = window.navigator.userAgentData.platform === 'Windows' || /Win/i.test(navigator.userAgent);
		isMacOS = window.navigator.userAgentData.platform === 'macOS' || /Mac/i.test(navigator.userAgent);
	} else if(window.navigator.platform) {
		isWindows = window.navigator.platform.toLowerCase().match(/^win\d+/i);
		isMacOS = window.navigator.platform.toLowerCase().match(/^mac/i);
	}

	if (isWindows) {
		document.querySelectorAll('.button--download-for-macos').forEach(el => {
			el.classList.add('button-download-secondary');
		});
	} else if (isMacOS) {
		document.querySelectorAll('.button--download-for-windows').forEach(el => {
			el.classList.add('button-download-secondary');
		});
	}
}
